import { render, staticRenderFns } from "./CrashControls.vue?vue&type=template&id=f06c8a02&scoped=true"
import script from "./CrashControls.vue?vue&type=script&lang=js"
export * from "./CrashControls.vue?vue&type=script&lang=js"
import style0 from "./CrashControls.vue?vue&type=style&index=0&id=f06c8a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06c8a02",
  null
  
)

export default component.exports